import { SupportedLocale } from '../enums';

export function isSupportedLocale(value: unknown): value is SupportedLocale {
  return Object.values(SupportedLocale).includes(value as SupportedLocale);
}
